import React from "react";
import MenuCard from "./MenuCard";

function MenuCategorySection({ category, items }) {
  if (!items || items.length === 0) return null;

  const isDrinks = items[0]?.menuType === "drinks";

  // Separate food items into Veg and Non-Veg sub-groups
  const vegItems = !isDrinks ? items.filter((i) => i.dietary?.vegetarian) : [];
  const nonVegItems = !isDrinks ? items.filter((i) => !i.dietary?.vegetarian) : [];

  return (
    <section
      id={`cat-${category.id}`}
      data-category-id={category.id}
      className="category-group classic-menu-section"
    >
      {/* Centered Bold Category Heading */}
      <div className="category-header-centered">
        <h2>{category.label.toUpperCase()}</h2>
        <div className="category-header-underline" />
      </div>

      {!isDrinks ? (
        <>
          {/* VEG Section */}
          {vegItems.length > 0 && (
            <div className="subcategory-block">
              <div className="subcategory-header veg">
                <h3>VEG</h3>
                <div className="subcategory-line veg-line" />
              </div>
              <div className="menu-classic-columns">
                {vegItems.map((item) => (
                  <MenuCard key={item.id} item={item} />
                ))}
              </div>
            </div>
          )}

          {/* NON-VEG Section */}
          {nonVegItems.length > 0 && (
            <div className="subcategory-block">
              <div className="subcategory-header non-veg">
                <h3>NON-VEG</h3>
                <div className="subcategory-line non-veg-line" />
              </div>
              <div className="menu-classic-columns">
                {nonVegItems.map((item) => (
                  <MenuCard key={item.id} item={item} />
                ))}
              </div>
            </div>
          )}
        </>
      ) : (
        /* Drinks Section */
        <div className="subcategory-block">
          <div className="menu-classic-columns">
            {items.map((item) => (
              <MenuCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default React.memo(MenuCategorySection);
